const isProcedimentoMaiorPorte = (procedimentoList: any[], procedimento, pIndex) => {
  const l = procedimentoList.filter(d => d.valor >= procedimento.valor)
  const pSort = l.sort((n1, n2) => {
    if (n1.valor > n2.valor) {
      return 1
    }

    if (n1.valor < n2.valor) {
      return -1
    }

    return 0
  })

  const pRemoveDuplicidade: any[] = []

  pSort.map((p) => {
    if (!pRemoveDuplicidade.some(g => g.valor === p.valor)) {
      pRemoveDuplicidade.push(p)
    }
    return p
  })

  const i = pSort.length === 1 ? procedimentoList.indexOf(pSort[0]) : procedimentoList.indexOf(pRemoveDuplicidade[pRemoveDuplicidade.length - 1])

  if (pIndex === i) {
    return true
  }
  return false
}

export default isProcedimentoMaiorPorte
